export default __webpack_public_path__ + "static/media/OverlookMap.23e66ebf.jpg";